// Some constants for the wizard - will be read into the store on app-load
import { IConstants, WizardProductKeyEnum } from '@theia-cc/shared/helpers';

export const CONSTANTS_EM = <IConstants>{
  wizardProductKey: WizardProductKeyEnum.em,
  APP_MAIN_ENTRY_STEP: 'where-to-install-charger',
  APP_ALLOWED_ENTRY_STEPS: ['where-to-install-charger', 'number-of-parkingspaces', 'contact'],
};
